import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";
import type { ElementOrNewElement } from "@/react/types/Element";
import { getElementIds } from "../shared/blockUtils";
import type { BlockMeta } from "../shared/blockUtils";

export const blockToElement = (block: BaseBlock): ElementOrNewElement => {
  const { elementId, elementableId } = getElementIds(block);
  const meta = block.meta as BlockMeta | undefined;

  return {
    id: elementId,
    type: "text",
    position: meta?.position ?? 0,
    elementable_id: elementableId,
    parent_element_id: meta?.parentElementId ?? null,
    attributes: {
      value: (block.props.value?.value as string) || "",
      text_type:
        (block.props.textType?.value as "title" | "subtitle") || "title",
    },
  } as ElementOrNewElement;
};
